export const attackerCategoryKeys = {
  all: ["attackerCategory"] as const,
  project: (projectId: string) => [...attackerCategoryKeys.all, "project", projectId] as const,
};
